(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1323],{

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92310);

/***/ }),

/***/ 27696:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/videa",
      function () {
        return __webpack_require__(74421);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 48px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 32px;\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GridWrapper = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Wrapper, {
        className: className,
        children: children
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d588b636-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L, _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.M */ .U.M);
/* harmony default export */ __webpack_exports__["Z"] = (GridWrapper);


/***/ }),

/***/ 26221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1887);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39321);




var Head = function(param) {
    var title = param.title, description = param.description, url = param.url, imageUrl = param.imageUrl, imageAlt = param.imageAlt, noIndex = param.noIndex;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: "Street of Code"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:site",
                content: "@StreetofCode1"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:locale",
                content: "sk_SK"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: imageUrl || _constants__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_LOGO_IMAGE_URL */ .PX
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image:alt",
                content: imageAlt || title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "google-site-verification",
                content: "FB24EUCOSSYhz39LdPTSNW4Yebc0El71AV7luRQcQQc"
            }),
            noIndex && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "robots",
                content: "noindex"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 41246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  align-self: center;\n  padding: 50px 32px 100px 32px;\n  width: clamp(320px, 100%, 1200px);\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageContentWrapper = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: children
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db8ecefa-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L);
/* harmony default export */ __webpack_exports__["Z"] = (PageContentWrapper);


/***/ }),

/***/ 74421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ videa; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(15714);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./src/components/PageContentWrapper.tsx
var PageContentWrapper = __webpack_require__(41246);
// EXTERNAL MODULE: ./src/components/NavBar.tsx + 1 modules
var NavBar = __webpack_require__(55270);
// EXTERNAL MODULE: ./src/components/Head.tsx
var Head = __webpack_require__(26221);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(80371);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(18473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(70638);
// EXTERNAL MODULE: ./src/components/core/NextLink.tsx
var NextLink = __webpack_require__(96791);
// EXTERNAL MODULE: ./src/components/core/Flex.tsx
var Flex = __webpack_require__(90656);
// EXTERNAL MODULE: ./src/components/core/Heading.tsx
var Heading = __webpack_require__(96169);
// EXTERNAL MODULE: ./src/components/core/Text.tsx
var Text = __webpack_require__(43195);
// EXTERNAL MODULE: ./src/components/GridWrapper.tsx
var GridWrapper = __webpack_require__(77497);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(81990);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(60071);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils.tsx
var utils = __webpack_require__(10447);
// EXTERNAL MODULE: ./src/theme/device.ts
var device = __webpack_require__(40592);
;// CONCATENATED MODULE: ./src/components/domain/youtube/YouTubePreviewCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 3.2em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 360px;\n  height: 500px;\n  padding: 16px 24px;\n  border-right: var(--color-accent) 4px solid;\n  border-left: var(--color-accent) 4px solid;\n  box-shadow: 0px 2px 2px var(--color-shadow), 0px -2px 2px var(--color-shadow);\n  border-radius: 16px;\n  transition: 250ms ease-in-out;\n\n  &:hover {\n    transform: scale(1.05);\n    transition: 250ms ease-in-out;\n    box-shadow: 0px 4px 10px var(--color-shadow),\n      0px -4px 10px var(--color-shadow);\n  }\n\n  @media ",
        " {\n    width: 345px;\n    height: 480px;\n  }\n\n  @media ",
        " {\n    width: 320px;\n    height: 440px;\n  }\n\n  @media ",
        " {\n    width: 300px;\n    height: 400px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 1.4;\n  height: 5.2em;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  opacity: 0.85;\n  word-break: break-word;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  // images will adapt to this size while preserving their aspect-ratio\n  width: 260px;\n  height: 260px;\n\n  [theme-type='DARK'] & {\n    filter: brightness(0.9);\n  }\n\n  img {\n    object-position: left;\n  }\n\n  @media ",
        " {\n    width: 180px;\n    height: 180px;\n  }\n\n  @media ",
        " {\n    width: 160px;\n    height: 160px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var VideoPreviewCard = function(param) {
    var video = param.video;
    var featuredImage = video.snippet.thumbnails.medium.url;
    var authorName = "Street of Code";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WrapperFlex, {
        direction: "column",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                direction: "column",
                gap: "18px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                        direction: "column",
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FixedSizedHeading, {
                                variant: "h6",
                                align: "center",
                                children: video.snippet.title
                            }),
                            video.snippet.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Excerpt, {
                                align: "center",
                                dangerouslySetInnerHTML: {
                                    __html: "<p>".concat(video.snippet.description, "</p>")
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            layout: "fill",
                            src: featuredImage,
                            alt: video.snippet.title || "",
                            objectFit: "contain",
                            priority: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PaddedFlex, {
                justifyContent: "space-between",
                alignSelf: "stretch",
                children: [
                    video.snippet.publishedAt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        size: "small",
                        children: (0,utils/* formatDate */.p6)(new Date(video.snippet.publishedAt.value))
                    }),
                    authorName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        align: "right",
                        children: authorName
                    })
                ]
            })
        ]
    });
};
var FixedSizedHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-dee4ad72-0"
})(_templateObject());
var WrapperFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dee4ad72-1"
})(_templateObject1(), device/* device.L */.U.L, device/* device.S */.U.S, device/* device.XS */.U.XS);
var PaddedFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dee4ad72-2"
})(_templateObject2());
var Excerpt = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-dee4ad72-3"
})(_templateObject3());
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dee4ad72-4"
})(_templateObject4(), device/* device.S */.U.S, device/* device.XS */.U.XS);
/* harmony default export */ var YouTubePreviewCard = (VideoPreviewCard);

// EXTERNAL MODULE: ./src/components/core/TextField.tsx
var TextField = __webpack_require__(3190);
;// CONCATENATED MODULE: ./src/components/domain/youtube/YouTubeVideos.tsx


function YouTubeVideos_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    YouTubeVideos_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function YouTubeVideos_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  max-width: 300px;\n"
    ]);
    YouTubeVideos_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var YouTubeVideos = function(param) {
    var videos = param.videos;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(videos), 2), filteredVideos = ref[0], setFilteredVideos = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), search = ref1[0], setSearch = ref1[1];
    react.useEffect(function() {
        if (!search) {
            setFilteredVideos(videos);
            return;
        }
        setFilteredVideos(videos.filter(function(video) {
            var title = video.snippet.title.toLowerCase();
            var description = video.snippet.description.toLowerCase();
            var searchLower = search.toLowerCase();
            return title.includes(searchLower) || description.includes(searchLower);
        }));
    }, [
        search,
        videos
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        direction: "column",
        gap: "36px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                direction: "column",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                inline: true,
                                align: "center",
                                variant: "h2",
                                children: "Naše"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Heading/* default */.Z, {
                                inline: true,
                                variant: "h2",
                                color: "accent",
                                align: "center",
                                children: [
                                    " ",
                                    "YouTube vide\xe1"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        align: "center",
                        children: "Rob\xedme vide\xe1 o všeličom. Javascript, Python, CSS, \xfavahy program\xe1tora, tipy pre program\xe1torov atď."
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        href: "https://www.youtube.com/@streetofcode",
                        target: "_blank",
                        children: "N\xe1š YouTube kan\xe1l n\xe1jdeš tu!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchTextField, {
                text: search,
                onTextChanged: function(e) {
                    return setSearch(e.target.value);
                },
                label: "Filtrovať",
                disableMultiline: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridWrapper/* default */.Z, {
                children: filteredVideos.map(function(video, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                        href: routes/* routes.videa.slug */._.videa.slug(video.id || ""),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YouTubePreviewCard, {
                            video: video
                        })
                    }, i);
                })
            })
        ]
    });
};
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1af2cd82-0"
})(YouTubeVideos_templateObject());
var SearchTextField = (0,styled_components_browser_esm/* default */.ZP)(TextField/* default */.Z).withConfig({
    componentId: "sc-1af2cd82-1"
})(YouTubeVideos_templateObject1());
/* harmony default export */ var youtube_YouTubeVideos = (YouTubeVideos);

;// CONCATENATED MODULE: ./src/pages/videa/index.tsx







var VideosPage = function(param) {
    var videos = param.videos;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* default */.Z, {
                title: "Vide\xe1 | Street of Code",
                description: "Rob\xedme vide\xe1 o všeličom. Javascript, Python, CSS, \xfavahy program\xe1tora, tipy pre program\xe1torov atď.",
                url: (0,routes/* prefixWithHost */.O)(routes/* routes.clanky.index */._.clanky.index)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavBar/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageContentWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(youtube_YouTubeVideos, {
                    videos: videos
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var videa = (VideosPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7138,5270,9774,2888,179], function() { return __webpack_exec__(27696); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);